import { css, cx } from "@emotion/css"

import ImageButton from "@p-ban/common/src/components/html/ImageButton"
import Spacer from "@p-ban/common/src/components/layout/Spacer"
import Modal from "@p-ban/common/src/components/lib/Modal"

import Text from "../ui/Text/Text"
import MyPageTheme from "./MyPageTheme"
import Divider from "./layout/Divider"

import closeButtonSrc from "./close.png"
import closeHoverButtonSrc from "./closeHover.png"

type Props = (
  | {
      title: string
      description?: React.ReactNode
    }
  | {
      title?: undefined
      description?: undefined
    }
) &
  React.ComponentProps<typeof Modal>

const MyPageModal = ({ title, description, onRequestClose, children, className, ...props }: Props) => {
  return (
    <Modal {...props} onRequestClose={onRequestClose} className={cx(styles.modal, className)}>
      {onRequestClose && (
        <ImageButton
          src={closeButtonSrc}
          hoverSrc={closeHoverButtonSrc}
          alt="閉じる"
          width={30}
          height={30}
          onClick={onRequestClose}
          className={styles.close}
        />
      )}
      <MyPageTheme>
        <div className={styles.overflowWrapper}>
          <div className={styles.content}>
            {title && (
              <>
                <div className={styles.title}>{title}</div>
                <Spacer size={60} />
                {description && (
                  <div className={styles.description}>
                    <Text>{description}</Text>
                  </div>
                )}
                {description && <Spacer size={20} />}
                <Divider />
              </>
            )}
            {children}
          </div>
        </div>
      </MyPageTheme>
    </Modal>
  )
}

export default MyPageModal

const styles = {
  modal: css`
    position: relative;
    padding: 0;
    overflow: visible;
  `,
  overflowWrapper: css`
    max-height: 90vh;
    overflow: auto;
  `,
  content: css`
    width: 850px;
    min-height: 368px;
    padding: 39px 54px 54px;
    border: 1px solid #c2cdd6;
  `,
  title: css`
    font-size: 24px;
  `,
  description: css`
    height: 40px;
  `,
  close: css`
    position: absolute;
    top: -35px;
    right: 0;
  `,
}
